import { createSlice } from '@reduxjs/toolkit';

export const todaysDealsSlice = createSlice({
	name: 'todaysDeals',
	initialState: {
		data: null,
	},
	reducers: {
		addTodaysDeals: function (state, action) {
			state.data = action.payload;
		},
	},
});

export const { addTodaysDeals } = todaysDealsSlice.actions;
export default todaysDealsSlice.reducer;
